const Value = () => {
  const rows = [
    {
      title: "Consumers Value Reputation",
      content: [
        "58% of U.S. adults consider a company’s reputation before purchasing",
        "Consumers are 4–6 times more likely to trust and buy from purpose-driven companies",
        "Ethical business practices build long-term customer loyalty",
      ],
      citation: "Source: Statista, 2023; Forbes, 2020",
    },
    {
      title: "Increases Brand Value",
      content: [
        "90% of companies say non-profit partnerships enhance their brand",
        "89% believe these collaborations strengthen their community impact",
      ],
      citation: "Source: PointApp, 2022; Nonprofits Source, 2023",
    },
    {
      title: "Reputation Impacts Investment Decisions",
      content: [
        "Investors increasingly consider reputation and social responsibility",
        "Ethical companies are seen as more stable and sustainable",
        "Companies with strong governance attract more financial backing",
      ],
      citation: "Source: PwC, 2024",
    },
    {
      title: "Attracting and Retaining Employees",
      content: [
        "Many individuals seek employment at companies that prioritize mission over profit and strive for positive social impact.",
        "75% of Gen Z and Millennials consider a company's community engagement and social impact when evaluating potential employers.",
      ],
      citation: "Source: Deloitte, 2024",
    },
  ];

  return (
    <section className="py-16 md:px-40 bg-gray-100">
      <div className="max-w-5xl mx-auto">
        {/* Section Title */}
        <h2 className="text-3xl font-semibold text-center mb-20">
          <span className="font-semibold text-6xl text-[#004E98]">Value</span>{" "}
          of Supporting <br />
          Ethical Business Practices
        </h2>

        {/* Rows */}
        <div className="space-y-8">
          {rows.map((row, index) => (
            <div
              key={index}
              className={`flex flex-col md:flex-row gap-6 ${
                index % 2 === 0 ? "md:flex-row-reverse" : ""
              }`}
            >
              {/* Left Column (Content as Bullet Points) */}
              <div className="w-full md:w-2/3 p-6 text-gray-600">
                <ul className="list-disc pl-6 space-y-2">
                  {row.content.map((point, index) => (
                    <li key={index}>
                      {point.split(" ").map((word, idx) => {
                        if (
                          word === "58%" ||
                          word === "90%" ||
                          word === "75%" ||
                          word === "4–6" ||
                          word === "times" ||
                          word === "89%" ||
                          word === "increasingly" ||
                          word === "attract" ||
                          word === "positive" ||
                          word === "social" ||
                          word === "impact."
                        ) {
                          return (
                            <span
                              key={idx}
                              className="text-[#004E98] font-bold"
                            >
                              {word}{" "}
                            </span>
                          );
                        }
                        return <span key={idx}>{word} </span>;
                      })}
                    </li>
                  ))}
                </ul>
                {/* Citation */}
                <p className="mt-4 text-xs italic text-gray-400 text-right">
                  {row.citation}
                </p>
              </div>

              {/* Right Column (Title with Highlighted Words) */}
              <div className="w-full md:w-1/3 bg-[#FFC369] shadow-lg rounded-lg p-6 text-black text-left pt-6 text-3xl">
                <h3 className="text-2xl font-semibold">
                  {row.title.split(" ").map((word, index) => {
                    if (word === "Consumers") {
                      return (
                        <span key={index} className="text-[#004E98] font-bold">
                          {word}{" "}
                        </span>
                      );
                    } else if (
                      word === "Brand" &&
                      row.title.includes("Brand Value")
                    ) {
                      return (
                        <span key={index} className="text-[#004E98] font-bold">
                          {word}{" "}
                        </span>
                      );
                    } else if (word === "Investment") {
                      return (
                        <span key={index} className="text-[#004E98] font-bold">
                          {word}{" "}
                        </span>
                      );
                    } else if (word === "Employees") {
                      return (
                        <span key={index} className="text-[#004E98] font-bold">
                          {word}{" "}
                        </span>
                      );
                    }
                    return <span key={index}>{word} </span>;
                  })}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Learn More Link */}
        <div className="mt-16 text-right">
          <a
            href="#research-evidence"
            className="inline-flex items-center text-[#039B86] font-semibold text-lg hover:underline"
          >
            Learn more with the support of Research and Evidence
            <svg
              className="w-5 h-5 ml-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              ></path>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Value;
